<template>
  <div>
    <span>【期間管理】</span>
    <div>
      <table class="table table-bordered">
        <caption>
          <button class='btn btn-success btn-sm' @click='saveperiod()'
            v-if='nosave'>儲存期間管理</button>
        </caption>
        <thead>
          <tr>
            <th colspan="2">
              <button type="button" @click='openperiod("insert")'
                class="btn btn-primary btn-sm">新增</button>
            </th>
            <th class='text-nowrap' style="width:50px;">啟用</th>
            <th style='width:320px'>期間日期</th>
            <th style='width:150px'>優惠售價</th>
            <th style='width:60px;'>排序</th>
            <th style='width:150px'>文宣</th>
            <th style='width:150px'>備註</th>
          </tr>
        </thead>
        <tbody>
          <!--  -->
          <tr v-for='(Offlist,index) in thdata.period' v-if='Offlist.delete !=1'
            :key="'TOFF__'+index">
            <th style='width:50px' class='text-center'>{{index+1}}</th>
            <td style='width:80px' class='text-center'>
              <button type="button" @click='openperiod("update",Offlist)'
                class="btn btn-primary btn-sm">管理</button>
              <button type="button" @click='deleteperiod(Offlist)'
                class="btn btn-danger btn-sm">移除</button>
            </td>
            <td>
              <input type="checkbox" :checked='Offlist.online=="1"' value='1'>
            </td>
            <td>{{Offlist.startdate |moment("YYYY/MM/DD (E)")}} -
              {{Offlist.enddate |moment("YYYY/MM/DD (E)")}}<br>共 <span
                class='text-danger text-monospace'>{{Offlist.enddate |moment("diff",Offlist.startdate,"days")}}</span>天
            </td>
            <td>
              <span v-if='Offlist.price.method=="setprice"'>
                指定價錢:{{Offlist.price.price |currency }}
              </span>
              <span v-else-if='Offlist.price.method=="discash"'>
                {{(baseData.price.sell - Offlist.price.price) | currency}}
                <small class='text-danger'>
                  {{getListname(costListname,{value:Offlist.price.method})}}{{Offlist.price.price | currency}}
                </small>
              </span>
              <span v-else-if='Offlist.price.method=="dispa"'>
                {{(baseData.price.sell * ((Offlist.price.price)/100)) | currency}}
                <small class='text-danger'>
                  {{getListname(costListname,{value:Offlist.price.method})}}{{100-Offlist.price.price}}%
                </small>
              </span>
            </td>
            <td>{{Offlist.order}}</td>
            <td>{{Offlist.name}}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-modal v-model='periodOpen.open' centered hide-header @ok='periodOpenSave'
      @cancel='periodOpenClose' @close='periodOpenClose' size="lg">
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="outline-success" @click="ok()">儲存</b-button>
        <b-button variant="outline-danger" @click="cancel()">不儲存關閉</b-button>
      </template>
      <div class="row no-gutters">
        <div class="col-12 d-flex flex-column">
          <div class="d-flex">
            <div class='d-flex'>
              <div class='px-1'>商品定價：</div>
              <div>{{baseData.price.base |currency}}</div>
            </div>
            <div class='d-flex'>
              <div class='px-1'>商品售價：</div>
              <div>{{baseData.price.sell |currency}}</div>
            </div>
            <div class='d-flex'>
              <div class='px-1'>商品成本：</div>
              <div>{{baseData.price.cost |currency}}</div>
            </div>
          </div>
          <div>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td style='vertical-align: middle'>
                    優惠期間
                  </td>
                  <td>
                    <div class='d-flex'>
                      <b-form-datepicker calendar-width="400px" v-model="getperindStart"
                        :min='new Date()' locale='zh-tw' style='width:230px;'
                        aria-controls="example-input"></b-form-datepicker>
                      <div class='d-flex align-items-center'>

                        <span class='px-1'>天數</span>
                        <b-form-input type='number' v-model='getthroughtdate' class="text-right"
                          style='width:5rem'>
                        </b-form-input>
                      </div>
                    </div>
                    <div class='d-flex mt-2'>
                      <div>起始日期：{{perioddata.starttime.format("YYYY/MM/DD")}}</div>
                      <div class='px-2'>~</div>
                      <div>到期日期：{{perioddata.endtime.format("YYYY/MM/DD")}}</div>
                    </div>
                  </td>
                  <td style='vertical-align: middle'>期間碼</td>
                  <td style='vertical-align: middle'>
                    <b-form-input style="width:100px;" :value="perioddata.code"
                      @input="changeT('code', $event,'perioddata')">
                    </b-form-input>
                  </td>
                </tr>
                <tr>
                  <td>優惠文宣</td>
                  <td>
                    <b-form-input :value="perioddata.name"
                      @input="changeT('name', $event,'perioddata')"></b-form-input>
                  </td>
                  <td>品名前綴</td>
                  <td>
                    <b-form-input :value="perioddata.pre"
                      @input="changeT('pre', $event,'perioddata')"></b-form-input>
                  </td>
                </tr>
                <tr>
                  <td>折扣方式</td>
                  <td colspan="3">
                    <div class="d-flex">
                      <b-form-radio-group :checked="perioddata.price.method"
                        @input="changeT('method', $event,'perioddata','price')">
                        <b-form-radio name="costModalRadio" :value="i.value"
                          v-for='i in costListname' :key='"KK__"+i.value'>{{i.name}}
                        </b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>折扣</td>
                  <td colspan="3">
                    <div class='d-flex align-items-center'
                      v-if='perioddata.price.method=="discash"'>
                      <b-input-group prepend="折價＄" append='元' class="mb-2 mr-sm-2 mb-sm-0"
                        style="width:180px">
                        <b-form-input type="number" class="text-right" style="height:100%"
                          :value="perioddata.price.price"
                          @input="changeT('price', $event,'perioddata','price')">
                        </b-form-input>
                      </b-input-group>
                    </div>
                    <div class='d-flex align-items-center' v-if='perioddata.price.method=="dispa"'>
                      <b-input-group prepend="打折" append='%' class="mb-2 mr-sm-2 mb-sm-0"
                        style="width:180px">
                        <b-form-input type="number" class="text-right" style="height:100%"
                          :value="perioddata.price.price"
                          @input="changeT('price', $event,'perioddata','price')">
                        </b-form-input>
                      </b-input-group>
                    </div>
                    <div class='d-flex align-items-center'
                      v-if='perioddata.price.method=="setprice"'>
                      <b-input-group prepend="指定＄" append="元" class="mb-2 mr-sm-2 mb-sm-0"
                        style="width:180px">
                        <b-form-input type="number" class="text-right" style="height:100%"
                          :value="perioddata.price.price"
                          @input="changeT('price', $event,'perioddata','price')">
                        </b-form-input>
                      </b-input-group>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td>備註</td>
                  <td>
                    <b-form-textarea type="number" style="height:100%" :value="perioddata.remark"
                      rows="3" @input="changeT('remark', $event,'perioddata')">
                    </b-form-textarea>
                  </td>
                  <td>排序</td>
                  <td>
                    <b-form-input class="text-right" style="height:100%;width:40px;"
                      :value="perioddata.order" @input="changeT('order', $event,'perioddata')">
                    </b-form-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import ctrl from "./betweenPrice.js"
  export default ctrl;

</script>
